import { formatLetterAvatar } from './formatLetterAvatar'
import type { Agent } from '@edge/spark/io-dashboards'

export const formatAgentLetterAvatar = (agent: Pick<Agent, 'firstName' | 'lastName'> | null | undefined): string => {
    if (!agent) {
        return ''
    }

    return formatLetterAvatar(agent.firstName) + formatLetterAvatar(agent.lastName)
}
